import { render, staticRenderFns } from "./DeliveryStage.vue?vue&type=template&id=0d96d786&scoped=true"
import script from "./DeliveryStage.vue?vue&type=script&lang=js"
export * from "./DeliveryStage.vue?vue&type=script&lang=js"
import style0 from "./DeliveryStage.vue?vue&type=style&index=0&id=0d96d786&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d96d786",
  null
  
)

export default component.exports